export default {
  list: { lazy: () => import('./GlobalRoles'), component: 'GlobalRoleList' },
  create: { lazy: () => import('./GlobalRoles'), component: 'GlobalRoleCreate' },
}
